import { Dispatch, SetStateAction } from 'react';

import { inputStyles } from '@/styles/input';

import { SearchIcon } from '@/ui/Icons/SearchIcon';

interface SearchBarProps {
  /** The label for the search bar. */
  label: string;
  /** The placeholder for the search input. */
  placeholder: string;
  /** The current search term. */
  searchTerm?: string;
  /** The function to set the search term. */
  setSearchTerm: Dispatch<SetStateAction<string | undefined>>;
}

/**
 * Component to display a search bar for the asset history.
 */
export const SearchBar = ({ label, placeholder, searchTerm, setSearchTerm }: SearchBarProps) => {
  const input = inputStyles();
  return (
    <div className="tablet:mr-3 w-full tablet:w-auto row-start-1 min-w-[140px]">
      <label htmlFor="asset-search" className="sr-only">
        {label}
      </label>
      <div className={input.root()}>
        <SearchIcon
          className={input.accessoryLeft({ class: ['w-4', 'h-4'] })}
          data-testid="search-icon"
        />
        <input
          role="searchbox"
          type="search"
          id="asset-search"
          value={searchTerm}
          placeholder={placeholder}
          className={input.input()}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>
  );
};
